/**
 * TipBox Component
 * Colored tip/alert boxes with icons for different types of information
 */

import React from 'react';
import { AnimatedContainer } from '../animations';

export type TipBoxType = 'info' | 'warning' | 'success' | 'tip';

export interface TipBoxProps {
  text: string;
  type: TipBoxType;
  delay?: number;
}

const TIP_CONFIG: Record<TipBoxType, { icon: string; color: string }> = {
  info: { icon: '💡', color: '#3b82f6' },
  warning: { icon: '⚠️', color: '#f59e0b' },
  success: { icon: '✅', color: '#10b981' },
  tip: { icon: '🌟', color: '#8b5cf6' },
};

export const TipBox: React.FC<TipBoxProps> = ({ text, type, delay = 0 }) => {
  const config = TIP_CONFIG[type];

  return (
    <AnimatedContainer animation="slideUp" delay={delay} duration={0.4}>
      <div className={`ai360-tip-box ai360-tip-box--${type}`}>
        <span className="ai360-tip-box-icon" role="img" aria-label={`${type} icon`}>
          {config.icon}
        </span>
        <p className="ai360-tip-box-text">{text}</p>
      </div>
    </AnimatedContainer>
  );
};
